import React from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { useAdminSessionQuery } from 'services/api/admin';
import { clearAdminSession, hasStoredAdminSession } from './adminSession';
import AdminLoginPage from './AdminLoginPage';
import AdminPage from '.';

function AdminSessionLoader() {
  return (
    <div className="d-flex align-items-center justify-content-center p-5">
      <Spinner animation="border" role="status" />
    </div>
  );
}

function AdminGate() {
  const location = useLocation();
  const hasLocalAdminSession = hasStoredAdminSession();
  const [, setSessionNonce] = React.useState(0);
  const { data, isLoading, isFetching, isError } =
    useAdminSessionQuery(undefined, {
      skip: !hasLocalAdminSession,
    });

  React.useEffect(() => {
    if (!hasLocalAdminSession) {
      clearAdminSession();
    }
  }, [hasLocalAdminSession]);

  const handleAuthenticated = React.useCallback(() => {
    setSessionNonce(value => value + 1);
  }, []);

  if (hasLocalAdminSession && (isLoading || isFetching)) {
    return <AdminSessionLoader />;
  }

  const isAdminAuthenticated = hasLocalAdminSession && data?.authenticated;

  if (hasLocalAdminSession && (isError || data?.authenticated === false)) {
    clearAdminSession();
  }

  if (!isAdminAuthenticated) {
    return <AdminLoginPage onAuthenticated={handleAuthenticated} />;
  }

  if (location.pathname === '/admin') {
    return <Redirect to="/admin/monitoring" />;
  }

  return (
    <Switch>
      <Route path="/admin" component={AdminPage} />
      <Route
        render={() => (
          <Alert variant="danger">Unable to load the admin route.</Alert>
        )}
      />
    </Switch>
  );
}

export default AdminGate;
